import React from 'react'
import cx from 'classnames'

import s from './Loader.scss'


export type LoaderProps = {
  className?: string
  name?: string
  error?: any
  style?: React.CSSProperties
  onClick?: React.MouseEventHandler<HTMLDivElement>
}


const Loader: React.FunctionComponent<LoaderProps> = (props) => {
  const { className, name, error, style, onClick } = props

  if (error) {
    console.error(error)
  }

  return (
    <div className={cx(s.loaderContainer, className)} style={style} data-name={name}>
      <div className={s.loader} onClick={onClick} />
    </div>
  )
}


export default Loader
